import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

import { reportSections } from '@/lib/reports/reportOptions';

import Icon from '@/components/base/Icon';

const TypeCell = ({ value }) => {
    const { t } = useTranslation();
    const reportType = reportSections(t)?.find((section) => section.type === value);
    return (
        <div className="flex h-14 items-center">
            {reportType ? (
                <div className="flex h-[42px] w-[42px] items-center justify-center rounded-full bg-icoBlue-100 text-icoBlue dark:bg-icoBlue/20">
                    <Icon icon={reportType?.icon} title={reportType?.label} />
                </div>
            ) : null}
        </div>
    );
};

TypeCell.propTypes = {
    value: PropTypes.string
};

export default TypeCell;
